// extracted by mini-css-extract-plugin
export default {"lostItemsForm":"lostItemsForm---fYcaZ","resetButton":"resetButton---hLyFd"};